import React, { FC } from 'react';
import { ProductModel } from '../table/ProductTableItem';
import { TitleModel } from '../table/TitleTableItem';
import ProductTable from '../table/ProductTable';
import PrintedPage from '../components/PrintedPage';

interface ProductPagesProps {
    sections: any[],
    startPage: number
}

const buildModels = (productGroups: any[]) => {
  const models: Array<ProductModel | TitleModel> = [];
  productGroups.forEach((group) => {
    const titleModel = {
      type: 'title',
      title: `${group.groupBy[0]}, ${group.groupBy[1]}`,
    } as TitleModel;
    const productModels = group.products.map((productAndPrice: any) => {
      const { product, price } = productAndPrice;
      const longDescription = `${product.inRutaShortDescriptionSpanish}, ${product.itemCount}/${product.itemServing} ${product.unit}`;
      return {
        type: 'product',
        image: product.image,
        longDescription,
        price,
      } as ProductModel;
    });
    models.push(titleModel);
    models.push(...productModels);
  });
  return models;
};

const ProductPages: FC<ProductPagesProps> = (props) => {
  // From a product list to table models
  const groupByCategoryThenByBrand = props?.sections;
  const itemModels = buildModels(groupByCategoryThenByBrand);

  // Group products by 18# groups
  let productBuffer: Array<ProductModel | TitleModel> = [];
  const pages: JSX.Element[] = [];
  let pageCounter = props?.startPage;
  itemModels.forEach((product: any) => {
    productBuffer.push(product);
    if (productBuffer.length === 18) {
      const page = (
        <PrintedPage
          pageTitle="Listado de Productos"
          pageNumber={pageCounter}
        >
          <ProductTable models={productBuffer} />
        </PrintedPage>
      );
      pages.push(page);
      productBuffer = [];
      pageCounter += 1;
    }
  });
  if (productBuffer.length > 0) {
    const page = (
      <PrintedPage pageNumber={pageCounter}>
        <ProductTable models={productBuffer} />
      </PrintedPage>
    );
    pages.push(page);
    productBuffer = [];
    pageCounter = 0;
  }
  return <>{pages}</>;
};

export default ProductPages;
